module.exports = __webpack_public_path__ + "img/hermione_in_sorting_hat.6eb3558e.jpg";